import { SessionEntityKind } from '../session/enums.js';

/**
 * Canonical short-id prefixes per entity kind.
 *
 * Mirrors `apps/bl/src/business-logic/orchestration/context/sid.ts` SID_PREFIX
 * (production BL convention). Every prefixed kind maps `prefix + numeric`
 * to the canonical short-id form (e.g. `p3`, `m2`, `rm5`).
 *
 * Version is the exception: `v` names the kind for parsing and DB
 * classification, but NO version is ever addressed as `v${n}`. A version's
 * short id is unique per (path, product), not per session, so
 * `content-version.entity.ts` overrides BOTH `canonical` and `formatted` to
 * `p${productN}/${versionN}` — that composite is the only form the session's
 * short-id dictionary holds and the only one a model-facing surface may emit.
 */
export const SHORT_ID_PREFIX: Record<SessionEntityKind, string> = {
  [SessionEntityKind.Product]: 'p',
  [SessionEntityKind.Version]: 'v',
  [SessionEntityKind.Collab]: 'c',
  [SessionEntityKind.Reflection]: 'r',
  [SessionEntityKind.Remark]: 'rm',
  [SessionEntityKind.Member]: 'm',
  [SessionEntityKind.User]: 'u',
  [SessionEntityKind.File]: 'f',
};
